export type StoreNoticeLevel = 'error' | 'warning';

export interface StoreNoticeOptions {
  description?: string;
}

export interface StoreNotice {
  level: StoreNoticeLevel;
  message: string;
  options?: StoreNoticeOptions;
}

export type StoreNoticeReporter = (notice: StoreNotice) => void;

let reportStoreNotice: StoreNoticeReporter = () => {};

/** Install the application-owned presentation adapter for domain-store notices. */
export function setStoreNoticeReporter(reporter: StoreNoticeReporter): void {
  reportStoreNotice = reporter;
}

export const storeNotice = {
  error(message: string, options?: StoreNoticeOptions): void {
    reportStoreNotice({ level: 'error', message, options });
  },
  warning(message: string, options?: StoreNoticeOptions): void {
    reportStoreNotice({ level: 'warning', message, options });
  },
};
